// ============================================================================
// CHINESE (SIMPLIFIED) TRANSLATIONS - BIBLE VERSES
// ============================================================================
// 鼓舞人心的经文集，附有斯特朗编号参考

export const bibleVerses = [
  {
    reference: "腓立比书 4:13",
    text: "我靠着那加给我力量的，凡事都能作",
    version: "和合本",
    theme: "力量",
    strongNumbers: {
      "能": "G1411", // δύναμις (dynamis) = 能力、力量
      "加力量": "G1743" // ἐνδυναμόω (endynamoo) = 加强
    },
    context: "保罗谈论他靠着基督有能力面对一切处境"
  },
  {
    reference: "诗篇 23:1",
    text: "耶和华是我的牧者，我必不至缺乏",
    version: "和合本",
    theme: "保护",
    strongNumbers: {
      "牧者": "H7462", // רָעָה (ra'ah) = 牧养、照顾
      "缺乏": "H2637" // חָסֵר (chaser) = 缺少、需要
    },
    context: "大卫表达对神供应的完全信靠"
  },
  {
    reference: "约翰福音 3:16",
    text: "神爱世人，甚至将他的独生子赐给他们",
    version: "和合本",
    theme: "爱",
    strongNumbers: {
      "爱": "G25", // ἀγαπάω (agapao) = 无条件的爱
      "赐": "G1325" // δίδωμι (didomi) = 给予、赐予
    },
    context: "关于神爱世人最著名的经文"
  },
  {
    reference: "腓立比书 4:7",
    text: "神所赐出人意外的平安，必在基督耶稣里保守你们的心怀意念",
    version: "和合本",
    theme: "平安",
    strongNumbers: {
      "平安": "G1515", // εἰρήνη (eirene) = 平安、和谐
      "保守": "G5432" // φρουρέω (phroureo) = 守护、保护
    },
    context: "神借着内在平安保护的应许"
  },
  {
    reference: "诗篇 119:105",
    text: "你的话是我脚前的灯，是我路上的光",
    version: "和合本",
    theme: "引导",
    strongNumbers: {
      "灯": "H5216", // נִיר (niyr) = 灯、光
      "光": "H216" // אוֹר (or) = 光、照明
    },
    context: "神的话语在日常生活中作为引导"
  },
  {
    reference: "箴言 3:5-6",
    text: "你要专心仰赖耶和华，不可倚靠自己的聪明",
    version: "和合本",
    theme: "信靠",
    strongNumbers: {
      "仰赖": "H982", // בָּטַח (batach) = 信靠
      "心": "H3820" // לֵב (leb) = 心、意、志
    },
    context: "呼召我们信靠神而非依赖自己的能力"
  },
  {
    reference: "马太福音 5:14",
    text: "你们是世上的光。城造在山上，是不能隐藏的",
    version: "和合本",
    theme: "见证",
    strongNumbers: {
      "光": "G5457", // φῶς (phos) = 光、属灵的照明
      "世": "G2889" // κόσμος (kosmos) = 世界、宇宙
    },
    context: "耶稣鼓励门徒在世上作见证"
  }
];

export default bibleVerses;
